import { render, staticRenderFns } from "./LiveView.vue?vue&type=template&id=0edcfa4d&scoped=true&"
import script from "./LiveView.vue?vue&type=script&lang=js&"
export * from "./LiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edcfa4d",
  null
  
)

export default component.exports